export default __webpack_public_path__ + "static/radovi6-59467407912a807e15da70a80635032e.png";